import { RESET_CURRENT_REPORT, SET_REPORT_ID, SET_CURRENT_REPORT, SET_REPORTS_LIST } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const resetCanteenReport = () => (dispatch) => dispatch({ type: RESET_CURRENT_REPORT });

export const getCanteenReport = (reportID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/canteen-reports/${reportID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_CURRENT_REPORT, payload: response.data.canteenReport });
    }
    catch (error) { errorHandler(error, null); }
};

export const getCanteenReports = (page, all) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/canteen-reports?page=${page}&all=${all}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_REPORTS_LIST, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const newCanteenReport = (formValues, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/canteen-reports`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_REPORT_ID, payload: response.data.reportID });
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const settleCantteenReport = (reportID) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/canteen-reports/settle/${reportID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};

export const cancelCantteenReport = (reportID) => async () => {
    try {
        console.log("test");
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/canteen-reports/cancel/${reportID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};